<template>
  <div class="registration-mgmt-wrapper">
    <div class="container">

      <Title>Registration Management</Title>
      <div class="card-section">
        <h3>Create new registration code</h3>
        <div class="registration-link-form">
          <div class="form-input-container">
            <label for="code-input">Code</label>
            <input class="input" type="text" id="code-input" name="code-input" v-model="newCode.code"
            @focus="showEmptyCodeError = false">
          </div>
          <div class="form-input-container">
            <label for="user-limit-input">Registrations possible</label>
            <input class="input" type="number" min="1" max="100" v-model="newCode.user_limit"
            @focus="showUserLimitNegativeError = false">
          </div>
          <div class="form-input-container">
            <label for="organization">Organization</label>
            <select class="input" id="organization" v-model="newCode.org_id">
              <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
            </select>
          </div>
        </div>
        <button class="button-primary" @click.prevent="createRegistration">Create</button>
        <p class="input-error" v-if="showEmptyCodeError">Code cannot be empty</p>
        <p class="input-error" v-if="showUserLimitNegativeError">Possible registrations must be positive</p>
      </div>

      <div class="card-section">
        <table class="table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Organization</th>
              <th>Status</th>
              <th>User limit</th>
              <th>Remaining</th>
              <th>Creator</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="registration in registrations">
            <td>{{ registration.code }}</td>
            <td>{{ registration.org_name }}</td>
            <td>
              <p :class="registration.active ? 'active' : 'inactive'">
                {{ registration.active ? 'Active' : 'Inactive' }}
              </p>
            </td>
            <td>{{ registration.user_limit }}</td>
            <td>{{ registration.user_limit - registration.signups }}</td>
            <td>{{ registration.creator_username }}</td>
            <td>
              <button v-if="!registration.active" class="activate-button" @click="activateRegistration(registration.id)">Activate</button>
              <button v-if="registration.active" class="deactivate-button" @click="deactivateRegistration(registration.id)">Deactivate</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script setup>
import Title from "@/components/common/Title.vue";
import {onMounted, ref} from "vue";
import apiService from "@/services/apiService";


const registrations = ref([]);
const organizations = ref([]);
const showEmptyCodeError = ref(false);
const showUserLimitNegativeError = ref(false);
const newCode = ref({
  code: "",
  user_limit: 1,
  org_id: 0
});

onMounted(async () => {
  await getRegistrations();
  await getOrganizations();
})

async function createRegistration() {
  if (newCode.value.code === "") {
    showEmptyCodeError.value = true;
    return;
  } else if (newCode.value.user_limit < 1) {
    showUserLimitNegativeError.value = true;
    return;
  }

  await apiService.createRegistration(newCode.value)
  await getRegistrations();
  emptyCodeObject();
}

async function getRegistrations() {
  registrations.value = await apiService.getRegistrations();
}

async function getOrganizations() {
  organizations.value = await apiService.getOrganizations();
}

function emptyCodeObject() {
  newCode.value.code = "";
  newCode.value.user_limit = 0;
}

async function deactivateRegistration(registration_id) {
  await apiService.deactivateRegistration(registration_id);
  await getRegistrations();
}

async function activateRegistration(registration_id) {
  await apiService.activateRegistration(registration_id);
  await getRegistrations();
}

</script>

<style scoped>

.registration-mgmt-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.card-section {
  background-color: white;
  border-radius: 6px;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
}

.registration-link-form {
  background-color: white;
  border-radius: 6px;
  border: 0.5px solid #13294B;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.registration-link-form {
  display: flex;
}

.form-input-container {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 30%;
  gap: 1rem;
}

.input {
  background-color: white;
}

#code-input {
  width: 60%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  font-size: 0.9rem;
}

th {
  background-color: #d4def3;
}

th:first-child {
  border-top-left-radius: 10px;
}

th:last-child {
  border-top-right-radius: 10px;
}

.active {
  margin: 0;
  background-color: #d1f4b0;
  width: fit-content;
  padding: 0.3rem;
  color: #156100;
  border-radius: 5px;
}

.inactive {
  margin: 0;
  background-color: #f4d7b0;
  width: fit-content;
  padding: 0.3rem;
  color: #613a00;
  border-radius: 5px;
}

.deactivate-button {
  margin: 0;
  background-color: #fbcaca;
  width: fit-content;
  padding: 0.3rem;
  color: #c10000;
  border-radius: 5px;
  border: none;
  transition: all 0.2s ease-in-out;
}

.deactivate-button:hover {
  background-color: #fbb4b4;
}

.activate-button {
  margin: 0;
  background-color: #cad8fb;
  width: fit-content;
  padding: 0.3rem;
  color: #0071c1;
  border-radius: 5px;
  border: none;
  transition: all 0.15s ease-in-out;
}

.activate-button:hover {
  background-color: #abc4ff;
}
</style>